import { z } from 'zod'

import type {
  CommonResponseSliceInquiryResponse,
  GenerateAttachmentPresignedUrlsData,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'
import { mapSliceContent, type Slice, sliceSchema } from '~/schema/slice'

import {
  type Inquiry,
  type InquiryAttachmentPresignedUrl,
  InquiryAttachmentPresignedUrlSchema,
  InquirySchema,
} from './schemas'

const ENTITY = 'Inquiry'

export const adaptInquiries = (raw: CommonResponseSliceInquiryResponse['data']): Slice<Inquiry> =>
  mapSliceContent(parseApiResponse(sliceSchema(InquirySchema), raw, ENTITY), (inquiry) => inquiry)

// 생성 타입은 응답 항목을 다른 API 의 같은 이름 클래스(Item: refId·result·code·msg)로 그린다. 서버의 실제 항목은
// InquiryAttachmentPresignedUrlResponse.Item(presignedUrl·s3Key·fileName·contentType)이다. 2026-10-13 백엔드
// develop 소스(cc5f60e17)로 확인. 스펙 생성기가 중첩 클래스 이름을 합치면서 생기는 차이라 이 한 줄에서만 unknown 을 거친다.
const asWire = (raw: GenerateAttachmentPresignedUrlsData): unknown => raw

export const adaptInquiryAttachmentPresignedUrls = (
  raw: GenerateAttachmentPresignedUrlsData,
): InquiryAttachmentPresignedUrl[] =>
  parseApiResponse(
    z.object({ items: z.array(InquiryAttachmentPresignedUrlSchema) }),
    asWire(raw),
    ENTITY,
  )?.items ?? []
